import { NgModule } from '@angular/core';
import { SFFormatDatePipe } from './SFFormatDate';
@NgModule({
    declarations: [SFFormatDatePipe],
    exports: [SFFormatDatePipe]
})
export class SFFormatDatePipeModule { }



// WEBPACK FOOTER //
// ./src/pipes/SFFormatDate.module.ts